import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { CreateIndividualAdditionalDataDTO } from "./type";
import type { IndividualAdditionalData } from "@typings/entities/individuals/additionalData";

export async function createIndividualAdditionalData(
  individualAdditionalData: CreateIndividualAdditionalDataDTO,
): Promise<IndividualAdditionalData> {
  const response = await apiClient.post<IndividualAdditionalData>(
    apiPaths.individuals.additionalData.create(individualAdditionalData.id),
    individualAdditionalData,
  );
  return response.data;
}
